<template>
  <div class="separator">
    <img src="@/assets/svg/story-part-divider.svg" :class="{ animate }" />
  </div>
</template>

<script>
export default {
  props: {
    index: {
      type: Number,
      default: () => -1
    },
    animate: {
      type: Boolean,
      default: () => true
    }
  }
};
</script>

<style lang="scss" scoped>
.separator {
  padding: 60px 0;
  text-align: center;

  img {
    animation: arrowAnim;
    animation-duration: 1.7s;
    animation-fill-mode: both;
    animation-timing-function: ease-in-out;

    &.animate {
      animation-iteration-count: infinite;
    }
  }
}

@keyframes arrowAnim {
  0% {
    transform: translateY(0);
  }

  58% {
    transform: translateY(0);
  }

  76% {
    transform: translateY(22px);
  }

  88% {
    transform: translateY(-11px);
  }

  to {
    transform: translateY(0);
  }
}
</style>
